import * as React from 'react';
import { useTranslation } from 'react-i18next';
import type { DailyAggregate } from '@etiquetachef/types';
import { BiTimeChart } from '@/features/dashboard-finance/charts/BiTimeChart';
import { formatInt, formatYyyymmddDisplay } from '@/features/dashboard-finance/formatters';

/**
 * Chart de etiquetas/dia (destaque) — KPI principal desta página.
 */
export function LabelsPerDayLargeChart({
  series,
}: {
  series: readonly DailyAggregate[];
}): React.JSX.Element {
  const { t } = useTranslation();
  const data = series.map((d) => ({
    x: formatYyyymmddDisplay(d.yyyymmdd),
    y: d.labels.printedToday ?? 0,
  }));
  return (
    <BiTimeChart
      title={t('usageBasic.charts.labels')}
      subtitle={t('usageBasic.charts.labelsHint')}
      type="line"
      data={data}
      color="#9333ea"
      valueFormatter={(v): string => formatInt(v)}
    />
  );
}
